/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_TagsInputs */



/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Transcript_Export_Field_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_tags = /** @type {((inputs?: Transcript_Export_Field_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tags")
	return /** @type {LocalizedString} */ ("Tags")
});